import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StopScreenShareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stop_screen_share"}/>
}
